import { ReactNode } from 'react';

import Tail from '@/icons/Tail';
import { cn } from '@/utils/twx';

const SpeechText = ({
  children,
  color = '#35373E',
  className = '',
}: {
  children: ReactNode;
  color?: string;
  className?: string;
}) => {
  return (
    <div className="relative h-min">
      <div
        className={cn('rounded-[10px] flex items-center justify-center', className)}
        style={{
          backgroundColor: color,
        }}
      >
        {children}
      </div>
      <div className="absolute left-[99%] top-[45%] transform -translate-y-1/2">
        <Tail />
      </div>
    </div>
  );
};

export default SpeechText;
